import { put, call } from 'redux-saga/effects'
import {
  handleError,
  operatorUserActionsApiService,
} from 'Services/ApiService.js'
import OperatorUserActionsAction from 'Stores/OperatorUserActions/Actions'
import { encodeObjectToBase64 } from '../Utils/base64functions'

export function* fetchOperatorUserActionsChargePoint({
  chargePointId,
  filter,
  offset,
}) {
  if (offset == 0) {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargePointLoading(),
    )
  } else {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargePointLoadingMore(),
    )
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(
      operatorUserActionsApiService.get,
      `/chargePoint/${chargePointId}`,
      {
        params: {
          filter: filter,
          offset: offset,
        },
      },
    )
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargePointSuccess(
        offset,
        data.results,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargePointFail(e),
    )
    handleError(e)
  }
}
export function* fetchOperatorUserActionsChargingToken({
  chargingTokenId,
  filter,
  offset,
}) {
  if (offset === 0) {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargingTokenLoading(),
    )
  } else {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargingTokenLoadMore(),
    )
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }

  try {
    const { data } = yield call(
      operatorUserActionsApiService.get,
      `/chargingToken/${chargingTokenId}`,
      {
        params: {
          filter: filter,
          offset: offset,
        },
      },
    )
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargingTokenSuccess(
        offset,
        data.results,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsChargingTokenFail(e),
    )
    handleError(e)
  }
}
export function* fetchOperatorUserActions({ filter, offset }) {
  if (offset == 0) {
    yield put(OperatorUserActionsAction.fetchOperatorUserActionsLoading())
  } else {
    yield put(OperatorUserActionsAction.fetchOperatorUserActionsLoadingMore())
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(operatorUserActionsApiService.get, '/', {
      params: {
        filter: filter,
        offset: offset,
      },
    })
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsSuccess(
        offset,
        data.results,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(OperatorUserActionsAction.fetchOperatorUserActionsFail(e))
    handleError(e)
  }
}
export function* fetchOperatorUserActionsUser({ userId, filter, offset }) {
  if (offset == 0) {
    yield put(OperatorUserActionsAction.fetchOperatorUserActionsUserLoading())
  } else {
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsUserLoadingMore(),
    )
  }
  if (filter != null) {
    filter = encodeObjectToBase64(filter)
  }
  try {
    const { data } = yield call(
      operatorUserActionsApiService.get,
      `/operatorUser/${userId}`,
      {
        params: {
          filter: filter,
          offset: offset,
        },
      },
    )
    yield put(
      OperatorUserActionsAction.fetchOperatorUserActionsUserSuccess(
        offset,
        data.results,
        data.nextOffset,
      ),
    )
  } catch (e) {
    yield put(OperatorUserActionsAction.fetchOperatorUserActionsUserFail(e))
    handleError(e)
  }
}
